import { requester } from '@shared/requester/requester'
import { useSuspenseQuery } from '@tanstack/react-query'

export const useContactsQuery = () =>
  useSuspenseQuery({
    queryKey:[ 'contacts' ],
    queryFn:async() => {
      const { data } = await requester.get('/main_page/footer/')
      return data
    },
  })